import React from 'react';
import styles from './Forbidden.module.scss';
import CyberSecurity from 'app/assets/CyberSecurity.svg';

export const Forbidden: React.FC = () => {
  return (
    <div className={styles.forbidden}>
      <div className={styles.content}>
        <img src={CyberSecurity} alt="Access denied" aria-hidden="true" />
        <h1>Access denied</h1>
        <p className="body-lg-r">
          We invite you to switch to our UAT version for testing and feedback.
        </p>
        <p className="body-lg-r">
          Please use the following URL{' '}
          <a href="https://nonprod-ai-bizservices.zurich.com/">
            GenAI Business Services Portal
          </a>
          {'.'}
        </p>
        <p className="body-lg-r">
          Your valuable input will shape our final product.
        </p>
        <p className="body-lg-r">Thank you!</p>
      </div>
    </div>
  );
};
